import { OrderBreakdown, Orderline, OrderlineDetails } from './OrderlineModel';
import { PackingList } from './PackingList';
export class Invoice {
  CCFee: number = 0;
  Id!: string;
  Breakdown!: OrderBreakdown;
  DueDate!: string;
  HasPackingList!: boolean;
  HasPaid!: boolean;
  InvoiceLineCount!: number;
  InvoiceLines!: InvoiceLine[];
  InvoiceNumber!: string;
  InvoiceTotal!: number;
  IsLoading: boolean = false;
  OrderDate!: string;
  OrderId!: string;
  OrderPO!: string;
  PaidDate!: string;
  PackingList!: PackingList;
  Status!: string;
  TotalAdjustedAmount!: number;
  TotalShipping!: number;
  TotalTax!: number;
  constructor(rawInvoice?: any) {
    this.Populate(rawInvoice);
  }
  Populate = (rawInvoice?: any) => {
    if (rawInvoice) {
      this.CCFee = rawInvoice.CCFee;
      this.Id = rawInvoice.Id;
      this.Breakdown = rawInvoice.Breakdown;
      this.DueDate = rawInvoice.DueDate;
      this.HasPackingList = rawInvoice.HasPackingList;
      this.HasPaid = rawInvoice.HasPaid;
      this.InvoiceLineCount = rawInvoice.InvoiceLineCount;
      this.InvoiceNumber = rawInvoice.InvoiceNumber;
      this.InvoiceTotal = rawInvoice.InvoiceTotal;
      this.OrderDate = rawInvoice.OrderDate;
      this.OrderId = rawInvoice.OrderId;
      this.OrderPO = rawInvoice.OrderPO;
      this.PaidDate = rawInvoice.PaidDate;
      this.TotalAdjustedAmount = rawInvoice.TotalAdjustedAmount;
      this.TotalShipping = rawInvoice.TotalShipping;
      this.TotalTax = rawInvoice.TotalTax;
      this.Status = rawInvoice.Status;
      this.InvoiceLines = rawInvoice.InvoiceLines.map((a: any) => new InvoiceLine(a));
      this.PackingList = new PackingList(rawInvoice.PackingList);
    } else {
      this.TotalShipping = 0;
      this.TotalAdjustedAmount = 0;
      this.TotalTax = 0;
    }
  };
}
export class InvoiceLine {
  Id!: string;
  AdjustedAmount!: number;
  Orderline!: OrderlineDetails;
  constructor(rawInvoiceLine?: any) {
    this.Populate(rawInvoiceLine);
  }
  Populate = (rawInvoiceLine?: any) => {
    if (rawInvoiceLine) {
      this.Id = rawInvoiceLine.Id;
      this.Orderline = new OrderlineDetails(rawInvoiceLine.OrderLine);
      this.AdjustedAmount = rawInvoiceLine.AdjustedAmount;
    }
  };
}
export enum InvoiceFilterType {
  Everything,
  Paid,
  Unpaid
}
export interface InvoicesState {
  invoices: Invoice[];
  filteredInvoices: Invoice[];
  filteringType: InvoiceFilterType;
  currentPage: number;
  error: boolean;
  isLoading: boolean;
  isDonePaginating: boolean;
  hasInvoices: boolean;
  hasFilteredInvoices: boolean;
}
